<template>
 <b-modal id="modalAvaliacao" ref="modalAvaliacao" modal-class="modal-avaliacao-jaleklinico" centered hide-footer>
       <div class="d-flex align-items-center px-4">
        <p class="mr-2"><strong>Sua avaliação:</strong></p>
        <div class="comp-star">
          <div class="star-rating ml-2" >
            <input type="radio" id="5-stars" name="rating" value="5" v-model="avaliacao" />
            <label for="5-stars" class="star"><i class="fas fa-star"></i></label>
            <input type="radio" id="4-stars" name="rating" value="4" v-model="avaliacao" />
            <label for="4-stars" class="star"><i class="fas fa-star"></i></label>
            <input type="radio" id="3-stars" name="rating" value="3" v-model="avaliacao" />
            <label for="3-stars" class="star"><i class="fas fa-star"></i></label>
            <input type="radio" id="2-stars" name="rating" value="2" v-model="avaliacao" />
            <label for="2-stars" class="star"><i class="fas fa-star"></i></label>
            <input type="radio" id="1-stars" name="rating" value="1" v-model="avaliacao" />
            <label for="1-stars" class="star"><i class="fas fa-star"></i></label>
          </div>
        </div>
      </div>
      <b-form-group
        class="px-4 my-4"
        label="Comente aqui o que achou do caso! Sua opinão nos ajuda a montar conteúdos sempre melhores. :)"
        label-for="textarea-avaliacao-jaleklinico"
      >
        <b-form-textarea
          id="textarea-avaliacao-jaleklinico"
          placeholder="Escreva aqui"
          rows="5"
          v-model="criticaElogio"
        ></b-form-textarea>
      </b-form-group>
      <div class="text-center my-4">
        <b-button class="btn btn-secondary" @click="enviarAvaliacao()">Enviar avaliação</b-button>
      </div>
  </b-modal>
</template>

<script>
import CasosApi from '../../../api/casos-api'
import Swal from 'sweetalert2'
export default {
  name: 'ModalCasoAvaliacao',
  inheritAttrs: false,
  props: {
    casoId: Number,
    avaliacao: Number
  },
  data () {
    return {
      criticaElogio: ''
    }
  },
  methods: {
    show: function () {
      this.$bvModal.show('modalAvaliacao')
    },
    async enviarAvaliacao () {
      let params = {
        avaliacao: this.avaliacao,
        comentario: this.criticaElogio,
        jaleklinico_id: this.casoId
      }
      await CasosApi.salvarAvaliacaoUsuario(params)
      this.close()
      Swal.fire({
        icon: 'success',
        showCloseButton: true,
        html: 'Obrigado pela sua avaliacao!' // TODO: Melhorar texto de agradecimento
      })
    },
    close () {
      this.$refs['modalAvaliacao'].hide()
      this.criticaElogio = ''
    }
  }
}
</script>

<style scoped>

</style>
